export const fetchUserDetails = async () => fetch(
    `/user-details`, {
        method: "GET",
        credentials: "include"
    }).then((response) => {
        if (response.ok) {
            return response.json();
        } else {
            return null
        }
    })
